import { render, staticRenderFns } from "./MandalaGoalTemplateItem.vue?vue&type=template&id=dc9ee4d6&scoped=true&"
import script from "./MandalaGoalTemplateItem.vue?vue&type=script&lang=js&"
export * from "./MandalaGoalTemplateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9ee4d6",
  null
  
)

export default component.exports